const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const BlogExperienceService = {
  /**
   * Envía una experiencia compartida al backend
   * @param {Object} experienceData - Datos de la experiencia
   * @param {string} experienceData.fullName - Nombre completo del usuario
   * @param {string} experienceData.email - Email del usuario
   * @param {string} experienceData.message - Mensaje/experiencia del usuario
   * @param {File[]} experienceData.images - Array de imágenes (opcional, máximo 10)
   * @returns {Promise<Object>} Respuesta del servidor
   */
  async submitExperience(experienceData) {
    try {
      // Crear FormData para manejar archivos
      const formData = new FormData();
      
      // Agregar campos básicos
      formData.append('full_name', experienceData.fullName);
      formData.append('email', experienceData.email);
      formData.append('message', experienceData.message);
      
      // Agregar imágenes si las hay
      if (experienceData.images && experienceData.images.length > 0) {
        experienceData.images.forEach((image, index) => {
          formData.append(`images_data`, image);
        });
      }
      
      const response = await fetch(`${API_BASE_URL}/blog/experience/`, {
        method: 'POST',
        body: formData, // No incluir Content-Type header, el navegador lo establecerá automáticamente
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Failed to submit experience. Please try again.');
      }
      
      return data;
    } catch (error) {
      console.error('Error submitting experience:', error);
      throw error;
    }
  },
};

export default BlogExperienceService;
